const FORMAT = {
  currency: 'currency',
  currency_full: 'currency-full',
  percentage: 'percentage',
  percentage_full: 'percentage-full',
}

const COLOR = {
  main: 'main',
  blue: 'blue',
  green: 'green',
  orange: 'orange',
  pink: 'pink',
  purple: 'purple',
}

export { FORMAT, COLOR }
